import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Typography, Box, Paper } from "@mui/material";
import { ReactComponent as DTVLogo } from "@/assets/DTV Logo.svg";
import { colors } from "@/theme";
import { useCart, useDealer } from "@/contexts";

const SessionSaved: React.FC = () => {
  const navigate = useNavigate();
  const { dealer, setNewSession } = useDealer();
  const { cart, clear } = useCart();

  const handleDoneClick = () => {
    clear?.();
    setNewSession();
    navigate("/login");
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        bgcolor: "#F5F6FA",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "97%",
          height: "95%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 16px 0 rgba(0,0,0,0.04)",
          borderRadius: 4,
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            mb: 8,
          }}
        >
          <DTVLogo
            style={{ width: "500px", height: "auto", display: "block" }}
          />
        </Box>
        <Typography
          component="h1"
          sx={{
            fontSize: 72,
            fontWeight: 500,
            color: colors.neutralGrey800,
            fontFamily: "PF DIN Text Pro",
          }}
        >
          Session Saved!
        </Typography>
        <Typography
          sx={{
            color: colors.neutralGrey800,
            fontWeight: 500,
            mb: 5,
            fontSize: '22px',
            fontFamily: "PF DIN Text Pro",
          }}
        >
          {dealer?.firstName +
            " " +
            dealer?.lastName +
            "-" +
            dealer?.company +
            " | " +
            `Order Number # ${cart?.orderId}`}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{
            borderRadius: 2,
            px: 5,
            mt: 5,
            py: 1.5,
            fontWeight: 500,
            fontSize: '22px',
            textTransform: "none",
            fontFamily: "PF DIN Text Pro",
          }}
          onClick={handleDoneClick}
        >
          Done
        </Button>
      </Paper>
    </Box>
  );
};

export default SessionSaved;
